import React, { useEffect, useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import ClipLoader from "react-spinners/ClipLoader";
import OutletHead from '../../../../components/common/outlet-head';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { EmailAuthProvider, getAuth, reauthenticateWithCredential, updatePassword, updateProfile } from 'firebase/auth';
import { storage } from '../../../../firebase';
import imgPlaceholder from '../../../../assets/images/placeholder/customer-image-placeholder.png';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { RotatingLines } from 'react-loader-spinner';

function AccountSettings() {

  const auth = getAuth();

  let navigate = useNavigate();

  const [isUpdating, setIsUpdating] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [data, setData] = useState({
    displayName: '',
    email: '',
    photoURL: ''
  });
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    password: '',
    confirmPassword: ''
  });
  const [inputError, setInputError] = useState();

  useEffect(() => {
    if (auth.currentUser) {
      setData({
        displayName: auth.currentUser.displayName ? auth.currentUser.displayName : '',
        email: auth.currentUser.email ? auth.currentUser.email : '',
        photoURL: auth.currentUser.photoURL ? auth.currentUser.photoURL : ''
      });
    }
  }, [auth]);

  function checkAndChangePassword(oldPass, newPass) {
    const cred = EmailAuthProvider.credential(auth.currentUser.email, oldPass);
    reauthenticateWithCredential(auth.currentUser, cred).then(() => {
      updatePassword(auth.currentUser, newPass).then(() => {
        setIsUpdating(false);
        toast.success('Password has been Changed.');
        setPasswordData({
          oldPassword: '',
          password: '',
          confirmPassword: ''
        });
      }).catch((error) => {
        setIsUpdating(false);
        toast.error(error.code);
      });
    }).catch((error) => {
      setIsUpdating(false);
      toast.error('Invalid password!');
      setInputError({ ...inputError, oldPassword: 'Please enter your valid old password!' });
    });
  }
  function handleUpdateProfileData(displayName, url) {
    const auth = getAuth();
    updateProfile(auth.currentUser, {
      displayName: displayName,
      photoURL: url,
    }).then(() => {
      toast.success('User updated, Successfully.');
      setIsUpdating(false);
    }).catch((error) => {
      console.log('Error updating user:', error);
    });
  }

  const uploadProfileImageToStorage = async (imageFile, userId) => {
    setIsUploading(true);
    const auth = getAuth();
    const storageRef = ref(storage, 'Profile/' + userId + '.jpeg');
    await uploadBytes(storageRef, imageFile);
    const url = await getDownloadURL(storageRef);
    updateProfile(auth.currentUser, {
      photoURL: url
    }).then(() => {
      toast.success('Profile photo updated, Successfully.');
      setIsUploading(false);
    }).catch((error) => {
      console.log('Error user profile updating :', error);
    });
  }

  function validateData() {
    const { displayName, photoURL } = data;
    const { oldPassword, password, confirmPassword } = passwordData;

    if (oldPassword || password || confirmPassword) {
      if (!oldPassword) {
        setInputError({ ...inputError, oldPassword: 'This field is required.' });
      } else if (!password) {
        setInputError({ ...inputError, password: 'This field is required.' });
      } else if (!confirmPassword) {
        setInputError({ ...inputError, confirmPassword: 'This field is required.' });
      } else if (password !== confirmPassword) {
        toast.error('Password do not Match!')
      } else {
        setIsUpdating(true);
        if (displayName !== auth.currentUser.displayName || photoURL !== auth.currentUser.photoURL) {
          handleUpdateProfileData(displayName, photoURL);
        }
        checkAndChangePassword(oldPassword, password);
      }
    } else {
      setIsUpdating(true);
      handleUpdateProfileData(displayName, photoURL);
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='custom-header'>
            <h5 className='mb-0 fw-600'>Account Settings</h5>
            <p className='mb-0 text-muted'>
              <small>Edit your account settings and information</small>
            </p>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              type="submit"
              className='border py-2 btn-width me-3'
              onClick={() => navigate('/admin/dashboard')}
            >
              <span className='px-4'>Cancel</span>
            </Button>
            <Button
              disabled={(data && auth && (data.displayName === auth.currentUser.displayName)) && (passwordData && (!passwordData.oldPassword || !passwordData.password || !passwordData.confirmPassword))}
              variant="primary"
              type="submit"
              className='py-2 btn-width'
              onClick={validateData}
            >
              {
                isUpdating ?
                  <div className='d-flex align-items-center justify-content-center'>
                    <span className='me-2'>Saving</span>
                    <ClipLoader color='white' size={16} />
                  </div>
                  :
                  <span>Save Changes</span>
              }
            </Button>
          </div>
        }
      />
      <div className='form-wrapper p-3 border-top' >
        <div className='row'>
          <div className='col-md-2 col-12 pe-md-0'>
            <div className='border overflow-hidden rounded p-3 d-flex align-items-center justify-content-center'>
              <Form.Group controlId="formPartyPhoto">
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(event) => uploadProfileImageToStorage(event.target.files[0], auth.currentUser.uid)}
                  hidden
                />
                <div className='position-relative'>
                  {
                    data && data.photoURL ?
                      <Image src={data.photoURL} className='cursor-pointer' fluid rounded onClick={() => document.getElementById('formPartyPhoto').click()} />
                      :
                      <Image src={imgPlaceholder} className='cursor-pointer' fluid rounded onClick={() => document.getElementById('formPartyPhoto').click()} />
                  }
                  {
                    isUploading ?
                      <div className="position-absolute top-0 bottom-0 left-0 right-0 bg-transparent-light w-100 h-100 rounded d-flex align-items-center justify-content-center">
                        <RotatingLines
                          height="40"
                          width="40"
                          strokeColor={`var(--bs-secondary)`}
                          strokeWidth="3"
                          animationDuration="1"
                        />
                      </div>
                      :
                      null
                  }
                </div>

                <div className='mt-3'>
                  <Button
                    variant='outline-primary'
                    size='sm'
                    className='w-100 border'
                    onClick={() => document.getElementById('formPartyPhoto').click()}
                  >
                    {auth && auth.currentUser.photoURL ? 'Change Photo' : 'Upload Photo'}
                  </Button>
                </div>
              </Form.Group>
            </div>
          </div>
          <div className='col-md-10 col-12'>
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-12 pe-md-0'>
                <div className='border overflow-hidden rounded p-3'>
                  <div className='row'>
                    <div className='col-12'>
                      <Form.Group className='mb-3' controlId="displayName">
                        <Form.Label>Display Name</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder="Enter your name"
                          onChange={(e) => setData({ ...data, displayName: e.target.value })}
                          value={data && data.displayName ? data.displayName : ''}
                        />
                      </Form.Group>

                      <Form.Group className='mb-3' controlId="email">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          disabled
                          readOnly
                          type='email'
                          placeholder="Enter your email address"
                          value={data && data.email ? data.email : ''}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-6 col-md-6 col-12'>
                <div className='border overflow-hidden rounded'>
                  <div className='row p-3'>
                    <div className='col-12'>
                      <Form.Group className='mb-3' controlId="oldPassword">
                        <Form.Label>Old Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter the password"
                          onChange={(e) => {
                            setPasswordData({
                              ...passwordData,
                              oldPassword: e.target.value,
                            });
                            setInputError({ ...inputError, oldPassword: '' })
                          }}
                          className={inputError && inputError.oldPassword ? 'border-danger' : null}
                          value={passwordData && passwordData.oldPassword ? passwordData.oldPassword : ''}
                          isInvalid={inputError && inputError.oldPassword}
                        />
                        <Form.Control.Feedback type="invalid">{inputError && inputError.oldPassword}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className='col-12'>
                      <Form.Group className='mb-3' controlId="password">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter the password"
                          onChange={(e) => {
                            setPasswordData({
                              ...passwordData,
                              password: e.target.value,
                            });
                            setInputError({ ...inputError, password: '' })
                          }}
                          className={inputError && inputError.password ? 'border-danger' : null}
                          value={passwordData && passwordData.password ? passwordData.password : ''}
                          isInvalid={inputError && inputError.password}
                        />
                        <Form.Control.Feedback type="invalid">{inputError && inputError.password}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className='col-12'>
                      <Form.Group className='mb-3' controlId="confirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter the password"
                          onChange={(e) => {
                            setPasswordData({
                              ...passwordData,
                              confirmPassword: e.target.value,
                            });
                            setInputError({ ...inputError, confirmPassword: '' })
                          }}
                          className={inputError && inputError.confirmPassword ? 'border-danger' : null}
                          value={passwordData && passwordData.confirmPassword ? passwordData.confirmPassword : ''}
                          isInvalid={inputError && inputError.confirmPassword}
                        />
                        <Form.Control.Feedback type="invalid">{inputError && inputError.confirmPassword}</Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AccountSettings;
